class PerformanceInvoice extends HTMLElement {
  connectedCallback() {
    this.form = document.getElementById('cart');
    if (!this.form) return;
    this.fields = Array.from(this.querySelectorAll('[data-invoice-field]'));
    this.rut = this.querySelector('[data-invoice-rut]');
    this.business = this.querySelector('[data-invoice-business]');
    this.personal = this.querySelector('[data-invoice-personal]');
    this.status = this.querySelector('[data-invoice-status]');
    this.onChange = () => { this.sync(); this.status.hidden = true; };
    this.onInput = () => { this.validateRut(); this.status.hidden = true; };
    this.onSubmit = (event) => {
      if (!this.invoiceSelected()) this.fields.forEach(field => {field.value = '';field.setCustomValidity('');});
      this.validateRut();
      if (!this.form.reportValidity()) event.preventDefault();
    };
    this.addEventListener('change',this.onChange);
    this.addEventListener('input',this.onInput);
    this.form.addEventListener('submit',this.onSubmit);
    this.sync();
    this.status.hidden = this.dataset.saved !== 'true';
  }
  disconnectedCallback() {
    this.removeEventListener('change',this.onChange);
    this.removeEventListener('input',this.onInput);
    this.form?.removeEventListener('submit',this.onSubmit);
  }
  invoiceSelected() { return this.querySelector('input[type="radio"]:checked')?.value === 'Factura'; }
  sync() {
    const invoice = this.invoiceSelected();
    this.business.hidden = !invoice;
    this.personal.hidden = invoice;
    this.fields.forEach(field => {field.required = invoice;});
    this.validateRut();
  }
  validateRut() {
    const value = this.rut.value.replace(/[.\s-]/g,'').toUpperCase();
    let valid = false;
    if (/^[0-9]{7,8}[0-9K]$/.test(value)) {
      const body = value.slice(0,-1);
      let sum = 0, factor = 2;
      for(let i = body.length - 1; i >= 0; i--) {sum += Number(body[i])*factor;factor = factor===7?2:factor+1;}
      const result = 11 - sum%11;
      const check = result===11?'0':result===10?'K':String(result);
      valid = check===value.slice(-1) && !/^0+$/.test(body);
    }
    this.rut.setCustomValidity(this.invoiceSelected() && value && !valid ? this.dataset.rutError : '');
  }
}
if (!customElements.get('pt-invoice')) customElements.define('pt-invoice',PerformanceInvoice);
